export default {
  blogs: [],
  pages: [],
  meta: {
    contacts: [],
    socials: {}
  },
  ui: {
    siteLoading: true,
    siteBroken: false,
    errorMessage: null
  }
};



// WEBPACK FOOTER //
// ./client/Site/State/InitialState.js